
import GridBodyRowCell from './index';
import { GridSizeStylesProps } from '../../../mixins/grid-size-styles';
import {
  CommonCellProps,
  CommonCellComputed,
} from './mixins/common-cell-props';

export default {
  name: 'GridBodyRowCellCustom',
  components: { GridBodyRowCell },
  mixins: [CommonCellProps, CommonCellComputed, GridSizeStylesProps],
};
